export default class Directives {
	static install(Vue, options) {
		Vue.directive('click-outside', {
			bind(el, binding) {
				el.dataset.directiveClickOutside = true;
				el.addEventListener('click', e => e.stopPropagation());
				document.body.addEventListener('click', binding.value);
			},
			unbind(el, binding) {
				document.body.removeEventListener('click', binding.value);
			}
		});
	}
}